import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
function generateErrorId() {
    // UUID v4 – browser-safe
    return crypto.randomUUID();
}
// Replace this with Sentry / Datadog / etc.
function logInvariantError(payload) {
    // Always keep console.error for local/dev visibility
    console.error("InvariantErrorBoundary caught an error", payload);
    // Example placeholder:
    // monitoringService.captureException(payload.error, {
    //   tags: { errorId: payload.errorId },
    //   extra: { componentStack: payload.componentStack },
    // });
}
export class InvariantErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
            errorId: "",
        };
    }
    static getDerivedStateFromError(_) {
        // Error ID must exist BEFORE first fallback render
        return {
            hasError: true,
            errorId: generateErrorId(),
        };
    }
    componentDidCatch(error, errorInfo) {
        logInvariantError({
            errorId: this.state.errorId,
            error,
            componentStack: errorInfo.componentStack ?? null,
        });
    }
    render() {
        if (this.state.hasError) {
            return (_jsxs("div", { role: "alert", style: {
                    padding: "2rem",
                    maxWidth: "600px",
                    margin: "4rem auto",
                    textAlign: "center",
                }, children: [_jsx("h2", { children: "We\u2019re unable to load your learning dashboard." }), _jsx("p", { children: "An internal consistency error occurred. Please contact support and share the error ID below." }), _jsxs("p", { children: [_jsx("strong", { children: "Error ID:" }), " ", this.state.errorId] })] }));
        }
        return this.props.children;
    }
}
